import { AuthorizePromoCodeRegistrationService } from 'types/services';
import { m8API } from '../m8';

const PROMO_USER_EMAIL = 'promo@mail.ru';

export const authorizePromoCodeRegistration: AuthorizePromoCodeRegistrationService = async (
  password
) => {
  await m8API.auth.signin({
    password,
    email: PROMO_USER_EMAIL,
  });
};
